<template>
  <div class="single_post_wrapper">
    <prismic-image :field="this.event.featured_image" class="featured_image"/>

    <div class="single_post_content">

      <div class="single_post_title">
        {{ $prismic.richTextAsPlain(this.event.event_title) }}
      </div>
      <div class="single_post_text">
        <prismic-rich-text :field="this.event.event_description"/>
      </div>

      <social-sharing url="" inline-template>
      <network network="facebook">
        <div class="single_post_share">
          <div class="single_post_share_icon">
            <img src="/facebook_white.svg" alt="">
          </div>
          <div class="single_post_share_text">
            PODIJELI
          </div>
        </div> <!-- single post share -->
      </network>
      </social-sharing>
    
    </div><!-- end single post content -->

    <div class="event_company_name">
      ShowConcept
    </div>

    <router-link to="/eventi">
      <div class="link_to_archive">
        POGLEDAJ SVE EVENTE
      </div>
    </router-link>

  </div><!-- end single post wrapper -->

</template>

<script>
import $ from 'jquery'

export default {
  name: 'Events',
  data () {
    return {
        event:[]
    }
  },
  methods: {
    getContent () {
         this.$prismic.client.getByUID('events', this.$route.params.uid)
        .then((document) => {
          if (document) {
            this.event = document.data
            //loader
            $('.loader_wrapper').fadeOut('slow').promise().done(function(){ 
              $('.single_post_wrapper').fadeIn('slow');
            });

          } else {
            this.$router.push({ name: 'not-found' })
          }
        })   
    }
  },
  mounted () {
    $(document).scrollTop(0);
    this.getContent();
    $('.single_post_wrapper').hide(); 
  },
  beforeCreate: function() {
      document.body.className = 'single_post';
      $('.loader_wrapper').css('display','flex');
  }
} 
</script>